<template lang="pug">
.opening-hours-editor
    .day-row(v-for="day in days" :key="day.key")
        .day-label {{ $t(day.label) }}
        .day-hours
            template(v-if="getHours(day.key).length === 0")
                span.closed {{ $t('Closed') }}
                el-button.add-btn(
                    type="text"
                    size="mini"
                    icon="el-icon-fa-plus fas"
                    @click="addTimeRange(day.key)"
                ) {{ $t('Add hours') }}
            template(v-else)
                .time-range(v-for="(range, index) in getHours(day.key)" :key="index")
                    el-time-select(
                        v-model="range.start"
                        :placeholder="$t('Start')"
                        :picker-options="startPickerOptions"
                        size="small"
                        @change="emitUpdate"
                    )
                    span.separator -
                    el-time-select(
                        v-model="range.end"
                        :placeholder="$t('End')"
                        :picker-options="getEndPickerOptions(range.start)"
                        size="small"
                        @change="emitUpdate"
                    )
                    el-button.remove-range-btn(
                        type="text"
                        icon="el-icon-fa-times fas"
                        size="mini"
                        @click="removeTimeRange(day.key, index)"
                    )
                el-button.add-another-btn(
                    type="text"
                    size="mini"
                    icon="el-icon-fa-plus fas"
                    @click="addTimeRange(day.key)"
                ) {{ $t('Add') }}
</template>

<i18n>
{
    "de": {
        "Monday": "Montag",
        "Tuesday": "Dienstag",
        "Wednesday": "Mittwoch",
        "Thursday": "Donnerstag",
        "Friday": "Freitag",
        "Saturday": "Samstag",
        "Sunday": "Sonntag",
        "Closed": "Geschlossen",
        "Add hours": "Öffnungszeiten hinzufügen",
        "Add": "Hinzufügen",
        "Start": "Von",
        "End": "Bis"
    }
}
</i18n>

<script>
import Vue from 'vue';

export default {
    name: 'OpeningHoursEditor',
    props: {
        value: {
            type: Object,
            default: () => ({
                monday: [],
                tuesday: [],
                wednesday: [],
                thursday: [],
                friday: [],
                saturday: [],
                sunday: []
            })
        }
    },
    data() {
        return {
            days: [
                { key: 'monday', label: 'Monday' },
                { key: 'tuesday', label: 'Tuesday' },
                { key: 'wednesday', label: 'Wednesday' },
                { key: 'thursday', label: 'Thursday' },
                { key: 'friday', label: 'Friday' },
                { key: 'saturday', label: 'Saturday' },
                { key: 'sunday', label: 'Sunday' }
            ],
            localValue: null,
            startPickerOptions: {
                start: '00:00',
                step: '00:30',
                end: '23:30'
            }
        };
    },
    computed: {
        hours() {
            return this.localValue || this.getDefaultHours();
        }
    },
    watch: {
        value: {
            immediate: true,
            deep: true,
            handler(newVal) {
                this.localValue = this.cloneValue(newVal);
            }
        }
    },
    methods: {
        getDefaultHours() {
            return {
                monday: [],
                tuesday: [],
                wednesday: [],
                thursday: [],
                friday: [],
                saturday: [],
                sunday: []
            };
        },
        cloneValue(val) {
            if (!val) return this.getDefaultHours();
            const result = {};
            this.days.forEach(day => {
                const dayHours = val[day.key] || [];
                result[day.key] = dayHours.map(range => ({
                    start: range.start || '',
                    end: range.end || ''
                }));
            });
            return result;
        },
        getHours(dayKey) {
            return this.hours[dayKey] || [];
        },
        getEndPickerOptions(startTime) {
            return {
                start: startTime || '00:00',
                step: '00:30',
                end: '24:00',
                minTime: startTime
            };
        },
        addTimeRange(dayKey) {
            if (!this.localValue[dayKey]) {
                Vue.set(this.localValue, dayKey, []);
            }
            this.localValue[dayKey].push({ start: '08:00', end: '20:00' });
            this.emitUpdate();
        },
        removeTimeRange(dayKey, index) {
            this.localValue[dayKey].splice(index, 1);
            this.emitUpdate();
        },
        emitUpdate() {
            this.$emit('input', this.localValue);
        }
    }
};
</script>

<style lang="sass" scoped>
.opening-hours-editor
    border: 1px solid #dcdfe6
    border-radius: 4px
    padding: 5px 15px
    line-height: 1.3

    .day-row
        display: flex
        align-items: center
        padding: 8px 0
        border-bottom: 1px solid #ebeef5

        &:last-child
            border-bottom: none

    .day-label
        width: 100px
        font-weight: 500
        flex-shrink: 0

    .day-hours
        flex: 1
        display: flex
        flex-wrap: wrap
        align-items: center
        gap: 8px

    .closed
        color: #909399
        font-size: 13px

    .time-range
        display: flex
        align-items: center
        gap: 5px

        .separator
            color: #909399
            padding: 0 3px

        .el-date-editor
            width: 100px

    .add-btn,
    .add-another-btn
        padding: 0
        font-size: 12px

    .remove-range-btn
        color: #f56c6c
        padding: 0 5px

        &:hover
            color: #f56c6c
</style>
